// Pure helpers for the "Tiered Customer Performance" widget. Kept free of
// React/redux so the per-period lookups and the "% of jobs with an issue"
// computation can be unit tested in isolation.
//
// The widget's backend response (result[0]) holds one object per issue row
// (uncoveredLabor / uncoveredMaterialStockout / qualities / shortages), each
// with per-period counts { wtd, qtd, ytd } (+ *FromDate/toDate for drill-down).
// It may also carry `totalJobs` ({ wtd, qtd, ytd }) and, optionally, an explicit
// `jobsWithIssue` ({ wtd, qtd, ytd }). All lookups default to 0 so the widget
// renders safely before/without those fields.

export const ISSUE_ROW_KEYS = [
  "uncoveredLabor",
  "uncoveredMaterialStockout",
  "qualities",
  "shortages",
];

// One issue-row count for a period (e.g. qualities.wtd), defaulting to 0.
export const getCell = (data, key, period) =>
  data && data[key] && data[key][period] != null
    ? Number(data[key][period]) || 0
    : 0;

// Total number of jobs for a period, defaulting to 0.
export const getTotalJobs = (data, period) =>
  data && data[period] != null
    ? Number(data[period]) || 0
    : 0;

// Jobs with any issue for a period. Prefers an explicit backend `jobsWithIssue`
// count (a job can have multiple issues, so a distinct backend count is most
// accurate); otherwise falls back to summing the issue rows.
export const getIssueJobs = (data, period, keys = ISSUE_ROW_KEYS) => {
  if (data && data[period] != null) {
    return Number(data[period]) || 0;
  }
  return 0;
  // return keys.reduce((sum, k) => sum + getCell(data, k, period), 0);
};

// Percent of jobs with an issue for a period, rounded to a whole number.
// Returns 0 when there are no jobs (avoids divide-by-zero).
export const getIssuePercent = (data, period, keys = ISSUE_ROW_KEYS) => {
  const totalPer = getIssueJobs(data, period);
  return totalPer;
};
